import React from 'react';

interface VerticalTableProps {
  title: React.ReactNode;
  details: { label: React.ReactNode; data: React.ReactNode }[];
  button?: React.ReactNode;
}

const VerticalTable: React.FC<VerticalTableProps> = ({ title, details, button }) => {
  return (
    details.length > 0 && (
      <>
        <div className="text-primary">
          <div className="mb-5 w-full justify-between md:flex md:flex-wrap">
            {title}
            <div className="hidden md:block">{button}</div>
          </div>
          <div className="flex flex-col gap-5">
            <div className="grid grid-cols-1 gap-6 md:grid-cols-[auto,1fr]">
              {details.map((item, i) =>
                item.data ? (
                  <React.Fragment key={i}>
                    <div className="w-full whitespace-nowrap text-lg font-light">{item.label}</div>
                    <div className="w-full break-words text-base font-normal md:w-3/4">{item.data}</div>
                  </React.Fragment>
                ) : null,
              )}
            </div>
          </div>
          <div className={`md:hidden ${button ? 'mt-5' : ''}`}>{button}</div>
        </div>
      </>
    )
  );
};

export default VerticalTable;
